
import { IRadioOption } from 'app/interfaces/IRadioOption';
import { ISelectOption } from 'app/interfaces/ISelectOption';
import { Type } from 'shell-models-lib';

export const enum UseSystemTrustStoreMode {
    NotUse = 0,
    Use = 1
}

export const useSystemTrustStoreOptions: Array<IRadioOption<UseSystemTrustStoreMode>> = [
    {
        label: stringResources.ModelName_UseSystemTrustStore,
        value: UseSystemTrustStoreMode.Use
    },
    {
        label: stringResources.Mysql_Not_Use_System_Trust_Store,
        value: UseSystemTrustStoreMode.NotUse
    }
];
export const enum SSLMode {
    Disabled = 0,
    Preferred = 1,
    Required = 2,
    Verify_ca = 3,
    Verify_identity = 4
}

export const sslModeOptions: Array<ISelectOption<SSLMode>> = [
    {
        label: stringResources.Disabled,
        value: SSLMode.Disabled
    },
    {
        label: stringResources.SSL_Mode_Preferred,
        value: SSLMode.Preferred
    },
    {
        label: stringResources.Required,
        value: SSLMode.Required
    },
    {
        label: stringResources.SSL_Mode_Verify_Ca,
        value: SSLMode.Verify_ca
    },
    {
        label: stringResources.SSL_Mode_Verify_identity,
        value: SSLMode.Verify_identity
    }
];

export const sslModeForAzureMySqlOptions: Array<ISelectOption<SSLMode>> = [
    {
        label: stringResources.Disabled,
        value: SSLMode.Disabled
    },
    {
        label: stringResources.SSL_Mode_Preferred,
        value: SSLMode.Preferred
    },
    {
        label: stringResources.Required,
        value: SSLMode.Required
    },
    {
        label: stringResources.SSL_Mode_Verify_Ca,
        value: SSLMode.Verify_ca
    }
];

export function convertToSSLMode(mode: string | undefined): SSLMode {
    if (mode == null) {
        return SSLMode.Preferred;
    }
    switch (mode.toUpperCase()) {
        case '0':
        case 'DISABLED':
            return SSLMode.Disabled;
        case '1':
        case 'PREFERRED':
            return SSLMode.Preferred;
        case '2':
        case 'REQUIRED':
            return SSLMode.Required;
        case '3':
        case 'VERIFY_CA':
            return SSLMode.Verify_ca;
        case '4':
        case 'VERIFY_IDENTITY':
            return SSLMode.Verify_identity;
        default:
            return SSLMode.Preferred;
    }
}

export function convertToUseSystemTrustStore(use: string | undefined): boolean {
    if (use == null) {
        return false;
    }
    switch (use.toUpperCase()) {
        case '0':
        case 'DISABLED':
            return false;
        case '1':
        case 'ENABLED':
            return true;
        default:
            return false;
    }
}

export type MysqlAdditionalPropertiesKeyType =
    | 'allowZeroDatetime'
    | 'connectionTimeout'
    | 'convertZeroDatetime'
    | 'guidFormat'
    | 'sslCert'
    | 'sslKey'
    | 'treatTinyAsBoolean';

export const mysqlAdditionalFieldsKeyOptions: Array<ISelectOption<MysqlAdditionalPropertiesKeyType>> = [
    {
        label: 'Allow zero dateTime',
        value: 'allowZeroDatetime',
        type: Type.Boolean
    },
    {
        label: 'Connection timeout',
        value: 'connectionTimeout',
        type: Type.Int
    },
    {
        label: 'Convert zero dateTime',
        value: 'convertZeroDatetime',
        type: Type.Boolean
    },
    {
        label: 'GUID format',
        value: 'guidFormat',
        type: Type.String
    },
    {
        label: 'SSL certificate',
        value: 'sslCert',
        type: Type.String
    },
    {
        label: 'SSL key',
        value: 'sslKey',
        type: Type.String
    },
    {
        label: 'Treat tiny as boolean',
        value: 'treatTinyAsBoolean',
        type: Type.Boolean
    }
];

export const mysqlAdditionalFieldsAllowedKeys: MysqlAdditionalPropertiesKeyType[] = mysqlAdditionalFieldsKeyOptions.map((option) => option.value);
